<script lang="ts" setup>
    const props = defineProps<{ blok: BenefitStoryblok }>();
</script>
<template>
    <div
        v-editable="blok"
        class="wrapper"
    >
        <div class="icon-container">
            <div class="icon">
                <StoryblokImage
                    v-if="props.blok.icon"
                    :media="props.blok.icon"
                    type="icon"
                    :alt="props.blok.icon.alt ? props.blok.icon.alt : ''"
                    :aria-hidden="true"
                    class="icon-image"
                    :class="props.blok.iconPadding ? '--padding-' + props.blok.iconPadding : ''"
                />
            </div>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="755.905"
                height="200mm"
                viewBox="0 0 200 200"
                class="circle-a"
                aria-hidden="true"
            >
                <defs>
                    <linearGradient id="a1">
                        <stop
                            offset="0"
                            style="stop-color: #e5c6e1; stop-opacity: 1"
                        />
                        <stop
                            offset="1"
                            style="stop-color: #e5c6e1; stop-opacity: 0"
                        />
                    </linearGradient>
                    <linearGradient
                        id="b1"
                        xlink:href="#a1"
                        x1="157.424"
                        x2="106.436"
                        y1="222.393"
                        y2="8.123"
                        gradientTransform="translate(-.357 -.633)"
                        gradientUnits="userSpaceOnUse"
                    />
                </defs>
                <circle
                    cx="135.957"
                    cy="121.723"
                    r="100"
                    style="fill: url(#b1); fill-opacity: 1; stroke-width: 0.263977"
                    transform="rotate(13.446 210.12 -41.656)"
                />
            </svg>

            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="755.905"
                height="200mm"
                viewBox="0 0 200 200"
                class="circle-b"
                aria-hidden="true"
            >
                <defs>
                    <linearGradient id="a2">
                        <stop
                            offset="0"
                            style="stop-color: #027f95; stop-opacity: 0.1"
                        />
                        <stop
                            offset="1"
                            style="stop-color: #027f95; stop-opacity: 0"
                        />
                    </linearGradient>
                    <linearGradient
                        id="b2"
                        xlink:href="#a2"
                        x1="157.424"
                        x2="106.436"
                        y1="222.393"
                        y2="8.123"
                        gradientTransform="translate(-.357 -.633)"
                        gradientUnits="userSpaceOnUse"
                    />
                </defs>
                <circle
                    cx="135.957"
                    cy="121.723"
                    r="100"
                    style="fill: url(#b2); fill-opacity: 1; stroke-width: 0.263977"
                    transform="rotate(13.446 210.12 -41.656)"
                />
            </svg>

            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="755.905"
                height="200mm"
                viewBox="0 0 200 200"
                class="circle-c"
                aria-hidden="true"
            >
                <defs>
                    <linearGradient id="a3">
                        <stop
                            offset="0"
                            style="stop-color: #f39324; stop-opacity: 0.1"
                        />
                        <stop
                            offset="1"
                            style="stop-color: #f39324; stop-opacity: 0"
                        />
                    </linearGradient>
                    <linearGradient
                        id="b3"
                        xlink:href="#a3"
                        x1="157.424"
                        x2="106.436"
                        y1="222.393"
                        y2="8.123"
                        gradientTransform="translate(-.357 -.633)"
                        gradientUnits="userSpaceOnUse"
                    />
                </defs>
                <circle
                    cx="135.957"
                    cy="121.723"
                    r="100"
                    style="fill: url(#b3); fill-opacity: 1; stroke-width: 0.263977"
                    transform="rotate(13.446 210.12 -41.656)"
                />
            </svg>
        </div>

        <h3 class="headline">{{ props.blok.headline }}</h3>
        <ATextComponent
            v-for="text in props.blok.text"
            :key="text._uid"
            :blok="text"
        />
    </div>
</template>
<style lang="scss" scoped>
    @import '~/assets/scss/pta-family/benefit.scss';
</style>
